import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/notifications/admin/adminNotificationAnalyticsQueryKeys.ts
var t = e("admin-notification-analytics", {
	summary: (e) => ["summary", e ?? "all"],
	timeseries: (e, t) => [
		"timeseries",
		e,
		t ?? "all"
	]
});
//#endregion
export { t as adminNotificationAnalyticsQueryKeys };
